import React from 'react';
import {
	useCreateHealthPlanUserMutation,
	useLazyHealthPlanIdQuery,
	useLazyHealthPlanUserQuery,
	useSubmitQuestionnaireResultMutation,
} from '../../../../graphql/graphql';
import { usePatientUpdate } from '../../../../Hooks/usePatient';
import apiClient from '../../../../Services/ApiClient';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import HealthPlanQuestionnaireForm from './HealthPlanQuestionnaireRevisionForm';
import { FormStructure } from './HealthPlanQuestionnaireRevisionForm.interface';
import { getMomentDate } from '../../../../Utils/dates.util';

interface HealthPlanQuestionnaireProps {
	onSuccess?: () => void;
	patientId: string;
	setIsLoading: (isLoading: boolean) => void;
	readOnly?: boolean;
}

const HealthPlanQuestionnaire: React.FC<HealthPlanQuestionnaireProps> = ({
	onSuccess,
	patientId,
	setIsLoading,
	readOnly,
}) => {
	const { healthPlan: healthPlanCtx } = useHealthPlanContext();
	const [getHealthPlanUser] = useLazyHealthPlanUserQuery();
	const [getHealthPlanId] = useLazyHealthPlanIdQuery();
	const [createHealthPlanUser] = useCreateHealthPlanUserMutation();

	const [submitQuestionnaireResult] = useSubmitQuestionnaireResultMutation();
	const { isSuccess, error, handleUpdate } = usePatientUpdate(patientId);

	const handleSubmit = async (values: FormStructure) => {
		console.log(values);
		values.menstruation.last = getMomentDate(values.menstruation.last).format(
			'YYYY-MM-DD',
		);
		console.log(values);

		setIsLoading(true);
		handleUpdate(values);

		if (!isSuccess && error !== undefined) return console.error(error);

		const { healthPlanUser } = await getHealthPlanUser({
			userId: patientId,
			healthPlanCode: healthPlanCtx?.code,
		}).unwrap();

		const questionnaireResult = await submitQuestionnaireResult({
			input: {
				data: values,
				questionnaireCode: healthPlanCtx.doctorInitialQuestionnaireCode,
				userId: patientId,
			},
		});

		if (!healthPlanUser) {
			const { healthPlan } = await getHealthPlanId({
				code: healthPlanCtx?.code,
			}).unwrap();

			if (healthPlan?.id) {
				await createHealthPlanUser({
					healthPlanId: healthPlan.id,
					userId: patientId,
					questionnaireResultId:
						questionnaireResult?.data?.submitQuestionnaireResult?.id,
				}).unwrap();
			}
		} else {
			await apiClient.patch(
				'/health-plan/' +
					healthPlanUser.healthPlanId +
					'/user/' +
					healthPlanUser.id,
				{
					// questionnaireResultId: data.questionnaireResultId,
				},
			);
		}
		onSuccess?.();
	};

	return (
		<ScrollContainer>
			<HealthPlanQuestionnaireForm
				userId={patientId}
				onSubmit={handleSubmit}
				healthPlanCode={healthPlanCtx.code || null}
				readOnly={readOnly}
			/>
		</ScrollContainer>
	);
};

export default HealthPlanQuestionnaire;
